<template>
    <div>
        <v-item-group
            :model-value="modelValue"
            class="option-btn-group-v2"
            :class="btnGridColsClass"
            @update:model-value="onChange($event)"
            v-bind="$attrs"
        >
            <!--
                NOTE: using "value === modelValue" vs "isSelected" is a workaround for a bug in vuetify
                where the isSelected value is not updated when page hydration occurs. Ignore the TS error.
            -->
            <v-item
                v-for="(opt, index) in options"
                :key="`item-${index}`"
                :value="opt.uid"
                #default="{ isSelected, toggle, value }"
            >
                <v-btn
                    :key="`option-${index}`"
                    variant="outlined"
                    class="rounded"
                    :class="{ 'selected': ((value as any) === modelValue) }"
                    @click="toggle"
                >
                    <strong>{{ opt.name }}</strong>
                </v-btn>
            </v-item>
        </v-item-group>
    </div>
</template>

<script lang="ts" setup>
    import type { GarmentSize } from '~/types';
    import { useDisplay } from 'vuetify';

    defineProps({
        modelValue: {
            type: String as PropType<Nullable<string>>,
            default: null
        },
        options: {
            type: Array as PropType<GarmentSize[]>,
            required: true
        }
    });

    const emit = defineEmits([
        'update:modelValue'
    ]);

    const { name: displayName } = useDisplay();
    const btnGridColsClass = computed<string>(() => {
        switch (displayName.value) {
            case 'xxl':
            case 'xl':
                return 'g-col-4';
            case 'lg':
            case 'md':
            case 'sm':
            case 'xs':
            default:
                return 'g-col-2';
        }
    });

    function onChange(value: Nullable<string>) {
        emit('update:modelValue', value ?? null);
    }
</script>

<style lang="scss"></style>
